import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { ADMIN_PAGES_KEYS, NS } from '../../../i18n/constants/keys';
import LoadingSpinner from '../../job_openings/create/ui/LoaderSpinner';
import { Tabs } from '../../assessment/view/tabs/tabs';
import { SettingsSubNav } from '../components/SettingsSubNav';
import { FrameworkStatsHeader } from './components';
import {
  JobTitleManagementContainer,
  SkillsManagementContainer,
} from './containers';
import { useAssessmentFramework } from './hooks';

export * from './components';
export * from './constants';
export * from './containers';
export * from './functions';
export * from './hooks';
export * from './interfaces';

export const AssessmentFramework = () => {
  const { t } = useTranslation(NS.adminPages);
  const {
    activeTab,
    setActiveTab,
    isLoading,
    skillsList,
    subSkillList,
    jobTitles,
  } = useAssessmentFramework();

  const tabTitles = [
    t(ADMIN_PAGES_KEYS.assessmentFramework.tabs.skills),
    t(ADMIN_PAGES_KEYS.assessmentFramework.tabs.jobTitles),
  ];

  const renderTabContent = () => {
    if (isLoading) {
      return (
        <Paper
          variant='outlined'
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 350,
            gap: 2,
            bgcolor: 'background.paper',
            borderRadius: '6px',
            borderColor: 'divider',
            p: 4,
            my: 2,
          }}
        >
          <LoadingSpinner label='' />
          <Typography
            sx={{
              fontSize: '0.75rem',
              fontWeight: 600,
              color: 'text.secondary',
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
            }}
          >
            {activeTab === 0
              ? 'Loading Skills & Sub-Skills...'
              : 'Loading Job Titles...'}
          </Typography>
        </Paper>
      );
    }

    if (activeTab === 0) {
      return (
        <SkillsManagementContainer
          skills={skillsList}
          subSkillList={subSkillList}
        />
      );
    } else if (activeTab === 1) {
      return <JobTitleManagementContainer jobTitles={jobTitles} />;
    }
  };

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', gap: 2.5 }}>
      <SettingsSubNav currentPath='/assessment-framework' />
      <FrameworkStatsHeader
        skillsCount={skillsList.length}
        subSkillsCount={subSkillList.length}
        jobTitlesCount={jobTitles.length}
      />

      <Box sx={{ width: '100%' }}>
        <Tabs
          tabTitles={tabTitles}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        {renderTabContent()}
      </Box>
    </Box>
  );
};
